import { useEffect } from 'react';
import { useStableFunction } from '../../core/hooks/use-stable-function';
import { Key } from './key';

export function useEscapeKeyListener(onEscapeKey: () => void, isActive: boolean = true) {
  const onEscapeKeyEvent = useStableFunction(onEscapeKey);

  useEffect(() => {
    if (!isActive) {
      return;
    }
    const listener = (event: KeyboardEvent) => {
      if (event.key === Key.Escape) {
        onEscapeKeyEvent();
      }
    };
    document.addEventListener('keyup', listener);
    return () => {
      document.removeEventListener('keyup', listener);
    };
  }, [isActive, onEscapeKeyEvent]);
}
